export enum ProviderType {
    VODAFONE = 'vodafone',
    TELEKOM = 'telekom'
}

export enum ProductType {
    DSL = 'dsl',
    FIBRE = 'fibre',
    CABLE = 'cable'
}

export enum MetacodePrefix {
    DSL = 'DSL',
    FIBER = 'FIB',
    CABLE = 'kip-',
    PRE_FIBER = 'PRE-FIB-',
}

export enum CableProviderType {
    KDG = 'kabel deutschland',
    UME = 'unitymedia'
}

export enum PreMarketingType {
    BHS = 'bhs',
    BKV = 'bkv',
    PRE_FIBER = 'pre-fiber',
}
